import { createConsumer } from '@rails/actioncable';

const URL = `${process.env.WEBSOCKET_HOST}/websockets`;
const consumer = createConsumer(URL);

export default consumer;
